import { createContext, useContext } from 'react'
import type { CueContextProps } from '../model/props'

const CueContext = createContext<CueContextProps | null>(null)
CueContext.displayName = 'CueContext'

export const useCueContext = () => {
  const context = useContext(CueContext)

  if (!context) {
    throw new Error('useCueContext must be used within a CueProvider')
  }

  return context
}

export { CueContext }
